import classNames from 'classnames'

const SpinnerIcon = ({ className }: { className: string }) => {
  return (
    <div className={classNames('border-2 rounded-full border-t-current border-r-current border-b-transparent border-l-transparent animate-spin', className)}></div>
  )
}

export default SpinnerIcon